import React from 'react';
import styles from './Metrics.module.scss';
import Portfolio from '../ReportMetrics/views/Portfolio';

/**
 * Project Intelligence across the whole workspace, before any project is open.
 *
 * The same Portfolio Overview that is page four of a project's report (spec
 * §17), rendered on its own: it never read anything about the open project, so
 * the only thing the report shell was giving it was a place to live. Reaching a
 * portfolio by first opening one arbitrary project was the odd part.
 *
 * Deliberately the same component rather than a second one, so the numbers here
 * and the numbers inside a project cannot drift apart. The page's header bar is
 * MetricsPage's, like every other page outside a project.
 */
const Metrics: React.FC = () => (
  <div className={styles.contentArea}>
    <Portfolio />
  </div>
);

export default Metrics;
